var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-group",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M19.426,13.534h0v9.333a1.752,1.752,0,0,1-1.75,1.75H7.759a1.752,1.752,0,0,1-1.75-1.75V13.535h0A2.331,2.331,0,0,1,8.343,11.2V22.285h8.75V11.2a2.331,2.331,0,0,1,2.333,2.332ZM15.343,11.2h-5.25v2.333h5.25ZM11.15,7.994V9.922h2.333V5.66A2.331,2.331,0,0,0,11.15,7.993h0ZM23.882,6.342a2.309,2.309,0,0,0-1.649-.681V17.035h-.944v2.333h1.527a1.752,1.752,0,0,0,1.75-1.75V7.994h0A2.314,2.314,0,0,0,23.882,6.342ZM15.233,7.994h5.25V5.66h-5.25ZM1.746,3.862v22.75a2.118,2.118,0,0,0,2.116,2.116h.972v-1.9H3.862a.218.218,0,0,1-.218-.218V3.862a.218.218,0,0,1,.218-.218h.972v-1.9H3.862A2.118,2.118,0,0,0,1.746,3.862ZM26.612,1.746H25.64v1.9h.972a.218.218,0,0,1,.218.218v22.75a.218.218,0,0,1-.218.218H25.64v1.9h.972a2.118,2.118,0,0,0,2.116-2.116V3.862A2.118,2.118,0,0,0,26.612,1.746Z",
    transform: "translate(-1.237 -1.237)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGroup);
export default __webpack_public_path__ + "static/media/ico-group.0c88601f38e47c5416d77869d5c04a67.svg";
export { ForwardRef as ReactComponent };